import React from "react";
import { Button, Modal } from "antd";

import classes from "./DocumentsSignModal.module.css";
import { EditOutlined } from "@ant-design/icons";

import EcpAnimationBlock from "../../EcpAnimationBlock/EcpAnimationBlock";
import { useClientSignModalState } from "../model/useClientSignModalState";
import { SelectSignOneApp } from "./SelectSignOneApp/SelectSignOneApp";
import { ConfirmText } from "./ConfirmText/ConfirmText";

interface DocumentsSignModalButtonProps {
  applicationBankId: number;
}

// Модалка для подписания документов заявки, открывается по кнопке
export const DocumentsSignModalButton = ({
  applicationBankId,
}: DocumentsSignModalButtonProps) => {
  const { modalView, isModalVisible, modalHandler } = useClientSignModalState(
    false,
    applicationBankId
  );

  return (
    <>
      <Button onClick={modalHandler.open} type="primary">
        <EditOutlined />
        Начать процесс подписания
      </Button>
      <Modal
        mask={false}
        title={false}
        open={isModalVisible}
        onCancel={modalHandler.cancel}
        footer={false}
        width={845}
        styles={{ body: { minHeight: 600 } }}
      >
        <div className={classes.wrapperModal}>
          <div className={classes.wrapperModalTitle}>
            <h2 className={classes.modalTitle}>Подписать документы</h2>
          </div>
          {/* Страница выбора подписи */}
          {modalView === "selectSign" && (
            <SelectSignOneApp
              closeModal={modalHandler.cancel}
              startSigning={modalHandler.signDocumentsByAppId}
              setModalView={modalHandler.setView}
              applicationBankId={applicationBankId}
            />
          )}
          {/* Страница принятия пользовательского соглашения */}
          {modalView === "confirmText" && (
            <ConfirmText setModalView={modalHandler.setView} />
          )}
          {/* Страница процесса подписания с анимацией */}
          {modalView === "ecpAnimation" ? <EcpAnimationBlock /> : null}
        </div>
      </Modal>
    </>
  );
};
